import React from 'react';
import FontAwesome from 'react-fontawesome';

import '../styles/Social.css';
import 'bootstrap/dist/css/bootstrap.css';

const Social = () => {
  return (
    <div className="footer">
      <a href="https://twitter.com/ProfJonesMusic">
        <FontAwesome
          className="social-icon"
          name="twitter"
          size="2x"
          style={{ color: 'white' }}
        />
      </a>
      <a href="https://www.facebook.com/ProfessorJonesMusic/">
        <FontAwesome
          className="social-icon"
          name="facebook"
          style={{ color: 'white' }}
        />
      </a>
      <a href="https://www.instagram.com/professorjonesmusic/">
        <FontAwesome
          className="social-icon"
          name="instagram"
          style={{ color: 'white' }}
        />
      </a>
      <a href="https://www.youtube.com/user/JeremyJonesBand/videos">
        <FontAwesome
          className="social-icon"
          name="youtube-play"
          style={{ color: 'white' }}
        />
      </a>
      <a href="https://itunes.apple.com/us/artist/jeremy-jones/357611345">
        <FontAwesome
          className="social-icon"
          name="music"
          style={{ color: 'white' }}
        />
      </a>
      <a href="https://open.spotify.com/album/4xWbt32pesTOklFx3Jr9Yc">
        <FontAwesome
          className="social-icon"
          name="spotify"
          style={{ color: 'white' }}
        />
      </a>
      <a href="https://soundcloud.com/professorjonesmusic">
        <FontAwesome
          className="social-icon"
          name="soundcloud"
          style={{ color: 'white' }}
        />
      </a>
    </div>
  );
};

export default Social;



// WEBPACK FOOTER //
// ./src/components/Social.js